import moment from 'moment';

export default class TimeSlotModel {
  constructor(data) {
    if (!data) {
      data = {};
    }

    this.start_time = moment(data.start_time).toDate();
    this.end_time = moment(data.end_time).toDate();
  }
}
